import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React, { useRef, useCallback, useEffect, useState } from 'react';
import List from './List';
import Card from './Card';
import { openFileDialog, getListFiles } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FileList = props => {
  var {
    uploadType,
    value = [],
    multiple = false,
    maxNumber = 3,
    onChange
  } = props;
  var inputRef = useRef(null);
  var inValue = value || [];
  var [fileList, setFileList] = useState([]);
  useEffect(() => {
    setFileList(inValue);
  }, [value]);
  var handleClickInput = useCallback(() => openFileDialog(inputRef), [inputRef]);
  var onFileUpload = useCallback(() => {
    if (inputRef.current) inputRef.current.value = '';
    handleClickInput();
  }, [handleClickInput]);
  var onInputChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (e) {
      var files = e.target.files;
      if (!files) return;
      var updatedFileList = yield getListFiles(files, 'dataURL');
      var updatedList = [...fileList, ...updatedFileList];
      if (maxNumber < updatedList.length) {
        updatedList = updatedList.slice(0, maxNumber);
      }
      setFileList(updatedList);
      onChange == null || onChange(updatedList);
    });
    return function onInputChange(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onRemove = index => {
    var updatedList = [...fileList];
    updatedList.splice(index, 1);
    setFileList(updatedList);
    onChange == null || onChange(updatedList);
  };
  var Comp;
  if (uploadType === 'card') {
    Comp = Card;
  }
  if (uploadType === 'picture' || uploadType === 'text') {
    Comp = List;
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx("input", {
      type: "file",
      ref: inputRef,
      multiple: multiple,
      style: {
        display: 'none'
      },
      onChange: onInputChange
    }), Comp && /*#__PURE__*/_jsx(Comp, _extends({}, props, {
      maxNumber: maxNumber || 3,
      dataList: fileList,
      onAdd: onFileUpload,
      onRemove: onRemove
    }))]
  });
};
export default FileList;